var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1794 5.49864C11.2553 11.0914 1.68717 13.3285 0.624023 5.49864C0.624023 -0.0941357 10.1162 -2.41114 11.1794 5.49864Z",
    fill: "#2C5B47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41075 7.79176V6.23362C6.42669 6.0171 6.39032 5.79992 6.30448 5.60242C6.27639 5.52739 6.23322 5.46023 6.17626 5.40614C6.11934 5.35213 6.05165 5.31261 5.978 5.29088C5.88841 5.23687 5.7836 5.21708 5.68182 5.23489C5.68182 5.23489 5.49949 5.23494 5.43877 5.43468V8.35095C5.38561 8.50275 5.55285 8.66263 5.71234 8.71057C5.87178 8.75851 5.81862 8.71041 5.87174 8.76634C6.00008 8.77137 6.12913 8.7526 6.25135 8.71057L6.30448 8.66249C6.36979 8.57277 6.40694 8.46393 6.41075 8.35095V7.79176Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94472 3.63714C4.92423 3.37731 4.99936 3.11921 5.15352 2.91548C5.30841 2.71174 5.5309 2.57768 5.77618 2.54093C6.02145 2.50425 6.27141 2.5676 6.47414 2.71789C6.67613 2.86817 6.81669 3.09402 6.86605 3.34953C6.88658 3.60935 6.81141 3.86767 6.65725 4.07141C6.50236 4.27514 6.27965 4.40899 6.03437 4.44574C5.7891 4.48249 5.53932 4.41929 5.33728 4.269C5.13455 4.11871 4.99408 3.89265 4.94472 3.63714Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.e77fbc33abb75f093dcf17bb7c21cda9.svg";
export { ForwardRef as ReactComponent };